import { memo, useCallback } from "react";

import type { ForNodeType } from "@/components/features/_model/types";

import { TextAreaField } from "@/components/ui/form/fields/text-area-field";

import { FormFieldLayout } from "../../layouts";

type Props = {
	discountDescription: ForNodeType<string>;
	onChangeDescription: (value: string) => void;
};

export const DiscountDescriptionFormFieldComposition = memo(({ discountDescription, onChangeDescription }: Props) => {
	/**
	 * ディスカウント名の変更
	 */
	const handleChangeDiscountDescription = useCallback(
		(value: string) => {
			onChangeDescription(value);
		},
		[onChangeDescription],
	);

	return (
		<FormFieldLayout title="ディスカウントの説明">
			<div className="space-y-2">
				<TextAreaField
					value={discountDescription.value}
					errorMessage={discountDescription.error}
					handleChange={handleChangeDiscountDescription}
				/>

				<p className="whitespace-pre-wrap text-sm text-caption-50">
					内部管理用のディスカウントの説明です。管理するスタッフの方に伝わりやすい説明で記入してください。
				</p>
			</div>
		</FormFieldLayout>
	);
});
